import styled from "@emotion/styled";
import { css } from "@emotion/css";

export const ModalStyles = styled("div")`
  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
    display: none;
  }
  .shadow--dark {
    background: rgba(0, 0, 0, 0.2);
  }
  .shadow.show {
    transition: opacity 0.15s linear;
    display: block;
  }
  .modal {
    max-width: 500px;
    margin: 5.75rem auto;
  }
  .modal-header {
    display: flex;
    justify-content: space-between;

    font-family:
      "Roboto",
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      "Fira Sans",
      "Droid Sans",
      "Helvetica Neue",
      sans-serif;

    &__close {
      padding: 0 1px 2px 1px;
      cursor: pointer;

      &:hover {
        background-color: rgba(51, 51, 204, 0.1);
        border-radius: 50%;
      }
    }
  }
  .modal-title {
  }
  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 15px 40px 0 rgba(35, 56, 129, 0.2);
    outline: 0;
    padding: 24px;
    box-sizing: border-box;

    font-family: "Open Sans";
    font-style: normal;
    font-size: 23px;
  }
`;

export const maxWidthHelper = function (width: any) {
  return width
    ? css`
        max-width: ${width}px !important;
      `
    : css``;
};
